<template>
  <v-container name="diakok-component">

  <div id="diakok_result">
    <center>
      <v-progress-circular
      :size="70"
      :width="7"
      color="red"
      indeterminate
      v-if="preloader"
    ></v-progress-circular>
    <div v-show="students" style="width: 98%;">

      <v-card>
        <v-card-title>
            Tanulók
      </v-card-title>

      <v-data-table
      v-if="students"
      :headers="students_header"
      :items="students"
      :mobile-breakpoint='NaN'
      show-expand
      item-key="customer_id"
      >
        <template v-slot:item.name="{ item }">
        <a @click="fetchStudentDetails(item.customer_id)">{{ item.name }}</a>
        </template>
        <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
          <v-btn icon @click="expand(true)" v-if="!isExpanded && item.contracts[0]['contract_id'] != 0" text><v-icon>list</v-icon></v-btn>
          <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon>keyboard_arrow_up</v-icon></v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <b>Szerződések:</b>
            <ul>
              <li v-for="c_item in item.contracts" :key="c_item['contract_id']" @click="fetchStudentDetailsWithContract(c_item['contract_id'], item.customer_id, c_item['contract_date'])">
                {{c_item['contract_name']}} {{c_item['contract_date']}}
              </li>
            </ul>
          </td>
        </template>
      </v-data-table>
      </v-card>

    </div>

    <div v-if="inquirer" style="width: 98%;">
      <v-card>
        <v-card-title>
          Érdeklődők
          <v-spacer></v-spacer>
          <v-select
            class="mt-6"
            v-model="csigaver_office_value"
            :items="csigaver_office"
            label="Helyszín"
            item-text="place_name"
            item-value="training_place_id"
            outlined
          ></v-select>
          <v-spacer></v-spacer>
          <v-select
            class="mt-6"
            v-model="inquiry_status_value"
            :items="inquiry_status"
            label="Státusz"
            item-text="label"
            outlined
          ></v-select>
          <v-spacer></v-spacer>
          <v-btn rounded color="primary" dark @click="csigaver_office_value = null, inquiry_status_value = null">Szűrők törlése</v-btn>
        </v-card-title>
        <v-data-table
          :headers="inquirer_headers"
          :items="inquirer"
          @click:row="inquirerDetails($event.customer_inquiry_id)"
          :mobile-breakpoint='NaN'
        ></v-data-table>
      </v-card>
    </div>

  </center>

  <v-dialog v-model="inquirer_dialog" persistent scrollable max-width="650px">
    <v-card>
      <v-card-title>
        <span class="headline">Érdeklődés részletei</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="inquirer_name" label="Érdeklődő neve" outlined disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field v-model="inquirer_email" label="E-mail cím" outlined></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="inquirer_phone" label="E-Telefonszám" outlined></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="inquirer_categroy" label="Kategróia" outlined disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="inquirer_place" label="Helyszín" outlined disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="inquirer_status"
                :items="inquiry_status"
                label="Státusz"
                item-text="label"
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                label="Tanulói megjegyzés"
                v-model="inquirer_comment"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                label="Belső megjegyzés"
                v-model="inquirer_office_comment"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                outlined
                label="Válasz üzenet"
                v-model="inquirer_reply"
              ></v-textarea>
              <v-btn outlined rounded color="primary" @click="inquirerMessage">Üzenet küldése
                <v-icon
                  right
                  dark
                >
                  send
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
            <v-btn color="primary" @click="Diakok_show = false, DiakokDetails_show = true, inquirer_dialog = false" outlined rounded>Tanulói adatlap
              <v-icon
                right
                dark
              >
                account_circle
              </v-icon>
            </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="inquirerUpdate">Mentés</v-btn>
        <v-btn color="primary" text @click="inquirer_dialog = false">Bezár</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>

  <v-snackbar v-model="archive_student_snackbar" bottom>
    {{archive_student_result}}
    <v-btn color="pink" text @click="archive_student_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

  </v-container>
</template>

<script>
import store from '../store'
import { mapFields } from 'vuex-map-fields'

  export default {
    data() {
      return {
        students_header: [
          { text: 'Név', value: 'name', width: 150},
          { text: 'Születési idő', value: 'birthdate', width: 120},
          { text: 'Rögzítés ideje', value: 'regdate', width: 130},
        ],
        inquirer_headers: [
          { text: 'Név', value: 'full_name', width: 150},
          { text: 'Kategória', value: 'category', width: 120},
          { text: 'Iroda', value: 'place_name', width: 130},
          { text: 'Dátum', value: 'creation_date', width: 130},
          { text: 'Státusz', value: 'status', width: 130},
        ],
        students: '',
        nev: '',
        error_text: '',
        student_details: '',
        archive_student_snackbar: false,
        archive_student_result: '',
        table_loading: false,
        csigaver_office: [],
        csigaver_office_value: '',
        inquiry_status: [],
        inquiry_status_value: '',
        inquirer: '',
        inquirer_dialog: false,
        inquirer_name: '',
        inquirer_date: '',
        inquirer_email: '',
        inquirer_phone: '',
        inquirer_categroy: '',
        inquirer_place: '',
        inquirer_comment: '',
        inquirer_status: '',
        inquirer_office_comment: '',
        inquirer_reply: '',
        inquirer_id: '',
      }
    },
    methods: {
      fetchStudents: async function() {
        this.table_loading = false
        this.students = null
        this.inquirer = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/diakok_search', {
          token: this.token,
          nev: this.search,
          archived: this.picked,
          student_type: this.student_type
        }).then((response) => {
          this.searching = false
          store.state.showing.preloader = false
          this.students = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      fetchStudentDetails (customer_id) {
        this.Diakok_show = false
        this.contract_id = null
        this.customer_id = null
        this.contract_date = null
        this.customer_id = customer_id
        this.DiakokDetails_show = true
        this.diakok_tab = 0
      },
      fetchStudentDetailsWithContract (contract_id, customer_id, contract_date) {
        this.Diakok_show = false
        this.contract_id = null
        this.customer_id = null
        this.contract_date = null
        this.contract_id = contract_id
        this.customer_id = customer_id
        this.contract_date = contract_date
        this.DiakokDetails_show = true
        this.diakok_tab = 0
      },
      fetchInquirer: async function() {
        this.table_loading = false
        this.students = null
        this.inquirer = null
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/inquirer_search', {
          token: this.token,
          nev: this.search,
          csigaver_office: this.csigaver_office_value,
          inquiry_status: this.inquiry_status_value
        }).then((response) => {
          this.searching = false
          store.state.showing.preloader = false
          this.inquirer = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      inquirerDetails: async function(customer_inquiry_id) {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/inquirer_details', {
          token: this.token,
          customer_inquiry_id: customer_inquiry_id,
        }).then((response) => {
          this.searching = false
          store.state.showing.preloader = false
          this.inquirer_dialog = true
          this.inquirer_name = response.data[0]['full_name']
          this.inquirer_date = response.data[0]['creation_date']
          this.inquirer_email = response.data[0]['email']
          this.inquirer_phone = response.data[0]['phone_number']
          this.inquirer_categroy = response.data[0]['category']
          this.inquirer_place = response.data[0]['place_name']
          this.inquirer_comment = response.data[0]['inquiry_comment']
          this.inquirer_office_comment = response.data[0]['description']
          this.inquirer_status = response.data[0]['status']
          this.inquirer_id = response.data[0]['customer_inquiry_id']
          this.customer_id = response.data[0]['customer_id']
          this.contract_id = null
          this.contract_date = null
          this.diakok_tab = 0
        }, (error) => {
          this.error_text = error.data
        })
      },
      inquirerUpdate: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/inquirer_update', {
          token: this.token,
          customer_inquiry_id: this.inquirer_id,
          inquirer_email: this.inquirer_email,
          inquirer_phone: this.inquirer_phone,
          inquirer_office_comment: this.inquirer_office_comment,
          inquirer_status: this.inquirer_status,
          customer_id: this.customer_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.fetchInquirer()
          this.archive_student_result = response.data
          this.archive_student_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      inquirerMessage: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/inquirer_message', {
          token: this.token,
          inquirer_reply: this.inquirer_reply,
          inquirer_email: this.inquirer_email,
        }).then((response) => {
          store.state.showing.preloader = false
          this.archive_student_result = response.data
          this.archive_student_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      fetchOffices: async function() {
        await this.gettoken()
        this.$http.post('/diakok/csigaver_office', {
          token: this.token
        }).then((response) => {
          this.csigaver_office = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
      fetchInquiryStatus: async function() {
        await this.gettoken()
        this.$http.post('/diakok/inquiry_status', {
          token: this.token
        }).then((response) => {
          this.inquiry_status = response.data
        }, (error) => {
          this.error_text = error.data
        })
      },
    },
    mounted() {
      this.fetchOffices()
      this.fetchInquiryStatus()
    },
    updated() {

    },
    created() {
      this.$eventBus.$on('archive_student_result', (data) => {
      this.archive_student_result = data
      this.archive_student_snackbar = true
      this.students = null
      });
    },
    watch: {
      Diakok_show: function (value) {
        if (value == true) {
          //this.fetchStudents()
        }
      },
      searching: function (value) {
        if (value == true) {
          if (this.student_type == 'inquirer') {
            this.fetchInquirer()
          } else {
            this.fetchStudents()
          }
        }
      },
      picked: function (value) {
          this.student_type = 'student'
          this.fetchStudents()
          this.Diakok_show = true
          this.DiakokDetails_show = false
      },
      student_type: function (value) {
        if (value == 'inquirer') {
          this.fetchInquirer()
        } else {
          this.fetchStudents()
        }
          this.Diakok_show = true
          this.DiakokDetails_show = false
      },
      csigaver_office_value() {
        this.fetchInquirer()
      },
      inquiry_status_value() {
        this.fetchInquirer()
      }
    },
    computed: {
    ...mapFields([
      'showing.preloader',
      'showing.Diakok_show',
      'showing.DiakokDetails_show',
      'diakok_details.contract_id',
      'diakok_details.customer_id',
      'diakok_details.contract_date',
      'diakok_details.search',
      'diakok_details.searching',
      'diakok_details.picked',
      'diakok_details.student_type',
      'diakok_details.diakok_tab',
  ]),
  },
  }
</script>

<style lang="css">
  li {
    cursor: pointer;
  }
</style>
